import { StateCodes } from "./StateCodes"

export const nDashPlaceholder = `\u2013`

export const formatPhone = number => {
  number = ("" + number).replace(/\D/g, "")
  if (number) number = "(" + number
  if (number.length > 4) {
    number = number.substring(0, 4) + ")" + number.substring(4)
  }
  if (number.length > 5) {
    number = number.substring(0, 5) + " " + number.substring(5)
  }
  if (number.length > 9) {
    number = number.substring(0, 9) + "-" + number.substring(9)
  }
  return number
}

export const formatHeight = height => {
  if (!isNaN(height.value.feet) && !isNaN(height.value.inches)) {
    return `${height.value.feet} ft. ${height.value.inches} in.`
  } else if (!isNaN(height.value.cm)) {
    return `${height.value.cm} cm.`
  } else {
    return nDashPlaceholder
  }
}

export const options = {
  sex: [{ text: "Male", value: "male" }, { text: "Female", value: "female" }],
  day: [...Array(31)].map((_, i) => ({
    text: i + 1,
    value: i + 1,
  })),
  month: [...Array(12)].map((_, i) => ({
    text: i + 1,
    value: i + 1,
  })),
  year: [...Array(99)].map((_, i) => ({
    text: new Date().getFullYear() - i,
    value: new Date().getFullYear() - i,
  })),
  state: StateCodes,
  height: {
    feet: [...Array(9)].map((_, i) => ({
      text: `${i} ft.`,
      value: i,
    })),
    inches: [...Array(12)].map((_, i) => ({
      text: `${i} in.`,
      value: i,
    })),
  },
  race: [
    "race: Asian or Pacific Islander",
    "race: Black",
    "race: Hispanic",
    "race: Middle Eastern",
    "race: Native American",
    "race: White",
  ].map(r => ({
    text: r.substr(6),
    value: r.toLowerCase(),
  })),
}

export const getOptText = (field, value, defaultValue) => {
  let option = null
  if (value) {
    option = options[field].find(o => o.value === value)
  } else if (defaultValue) {
    option = options[field].find(o => o.value === defaultValue)
  }
  return option ? option.text : ""
}

export const formatDate = (day, month, year, selected, birthdayNeeded) => {
  if (birthdayNeeded && selected && selected.age) {
    return Math.floor(new Date().getFullYear() - selected.age)
  }
  day = day.value || selected.day
  month = month.value || selected.month
  year = year.value || selected.year
  if (day === undefined || month === undefined || year === undefined) {
    return ``
  }
  day = String(day).length === 1 ? `0${day}` : day
  month = String(month).length === 1 ? `0${month}` : month
  return `${month}/${day}/${year}`
}

const keyReplacements = {
  first_name: "first",
  last_name: "last",
}

export const populateUserDetailStateWithProfile = (
  initialState,
  selectedProfile
) => {
  const newState = { ...initialState }

  Object.keys(selectedProfile).forEach(key => {
    if (keyReplacements[key]) {
      selectedProfile[keyReplacements[key]] = selectedProfile[key]
      key = keyReplacements[key]
    }
    if (key === "height") {
      newState[key].value = {}
      newState[key].value.feet = Math.floor(selectedProfile[key] / 12)
      newState[key].value.inches = selectedProfile[key] % 12
      newState[key].valid = newState[key].validate(newState[key].value)
    } else if (newState[key]) {
      newState[key].value = selectedProfile[key]
      newState[key].valid = newState[key].validate(newState[key].value)
    }
  })

  return newState
}

export const computeBasicInfoCardCompletion = (
  fields,
  questions,
  formConfig
) => {
  const totalFields = Object.keys(fields).map(k => formConfig[k])
  const validFields = totalFields.filter(p => p && p.valid).length

  const numOfQuestions = questions ? questions.length : 0

  const answeredQuestions = questions
    ? questions.filter(q => q.answer).length
    : 0

  return (
    Math.ceil(
      (validFields + answeredQuestions) /
        (totalFields.length + numOfQuestions) *
        100 /
        5
    ) * 5
  )
}

export const computeHealthCardCompletion = questions => {
  const extensions = questions.reduce(
    (total, q) =>
      Object.keys(q.options).some(k => q.options[k].extensions.length)
        ? ++total
        : total,
    0
  )
  const questionValue = (100 - extensions * 5) / questions.length

  const percent = questions.reduce((total, q) => {
    const extensionAnswered =
      q.answer &&
      q.options[q.answer].extensions.length > 0 &&
      q.options[q.answer].extensions.every(e => e.answer)
    const extensionNegated =
      q.answer &&
      q.options[q.answer].extensions.length === 0 &&
      Object.keys(q.options).some(k => q.options[k].extensions.length > 0)
    if (extensionAnswered || extensionNegated) {
      return total + questionValue + 5
    } else if (q.answer) {
      return total + questionValue
    } else {
      return total
    }
  }, 0)

  return percent > 100 ? 100 : Math.ceil(percent / 5) * 5
}

export const computeMedicalHistoryCompletion = categories => {
  let percent = 0
  categories.forEach(questions => {
    let questionValue = 100 / categories.length / questions.length

    percent += questions.reduce((total, q) => {
      if (
        (q.answer &&
          q.options[q.answer].extensions.length > 0 &&
          q.options[q.answer].extensions.every(e => e.answer)) ||
        (q.answer && q.options[q.answer].extensions.length === 0)
      ) {
        return total + questionValue
      } else {
        return total
      }
    }, 0)
  })
  percent = Math.round(percent / 5) * 5
  return percent > 100 ? 100 : percent
}



// WEBPACK FOOTER //
// ./assets/account/components/userDetailsUtilities.js